import React, {useEffect, useState} from 'react';
import s from './ConstructorPage.module.css'
import MenuComponent from "./MenuComponent/MenuComponent";
import GameConstructor from "./Constructors/GameConstructor/GameConstructor";
import EntityConstructor from "./Constructors/EntityConstructor/EntityConstructor";
import entityService from "../../Service/EntityService";
import Loader from "../Static/Loader/Loader";
import ModalWindow from "../Static/ModalWindow/ModalWindow";
import RoutConstructorComponent from "./Constructors/RoutConstructor/RoutConstructor.component";

const ConstructorPage = () => {
    const [pointMenu, setPointMenu] = useState('none')
    const [games, setGames] = useState([])
    const [levels, setLevels] = useState(null)
    const [tasks, setTasks] = useState(null)
    const [additionalTasks, setAdditionalTasks] = useState(null)
    const [isLoad, setIsLoad] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(()=>{
        init()
    },[])

    const init = async ()=>{
        setIsLoad(false)
        try{
            await loadLevel()
            await loadGames()
            await loadTasks()
            await loadAdditionalTasks()
        } catch(error){
            console.log(error)
            setErrorMessage(error)
        } finally{
            setIsLoad(true)
        }
    }

    const gameEntityName = "game"
    const levelEntityName = "level"
    const taskEntityName = "task"
    const additionalTaskEntityName = "additional_task"

    const loadLevel = async () => {
        const result = await entityService.getAll(levelEntityName)
        setLevels(result)
    }

    const loadGames = async () => {
        const resultGames = await entityService.getAll(gameEntityName)
        setGames(resultGames)
    }

    const loadTasks = async () => {
        const result = await entityService.getAll(taskEntityName)
        setTasks(result)
    }

    const loadAdditionalTasks = async () => {
        const result = await entityService.getAll(additionalTaskEntityName)
        setAdditionalTasks(result)
    }

    const points = [
        // {point:'user', pointName:'Пользователи'},
        {point:'game', pointName:'Игры'},
        {point:'rout', pointName:'Маршрут'},
        {point:'level', pointName:'Локации'},
        {point:'task', pointName:'Задания'},
        {point:'additionalTask', pointName:'Дополнительные задания'},
    ]

    return (
        <div className={s.wrapper}>
            <MenuComponent setPoint={setPointMenu} activePoint={pointMenu} points={points}/>

            {pointMenu?.point === "game"&& <GameConstructor games={games} levels={levels} setGames={setGames} setIsLoad={setIsLoad} gameEntityName={gameEntityName} levelEntityName={levelEntityName} setErrorMessage={setErrorMessage} />}
            {pointMenu?.point === "rout"&& <RoutConstructorComponent gameEntityName={gameEntityName} setErrorMessage={setErrorMessage} setIsLoad={setIsLoad} games={games} setGames={setGames} levels={levels} />}
            {pointMenu?.point === "level"&&  <EntityConstructor additionalTasks={additionalTasks} tasks={tasks} entities={levels} setEntity={setLevels} setIsLoad={setIsLoad} setErrorMessage={setErrorMessage} entityName={levelEntityName}  />}
            {pointMenu?.point === "task"&&  <EntityConstructor entities={tasks} entityName={taskEntityName} setEntity={setTasks} setIsLoad={setIsLoad} setErrorMessage={setErrorMessage} />}
            {pointMenu?.point === "additionalTask"&& <EntityConstructor entities={additionalTasks} entityName={additionalTaskEntityName} setEntity={setAdditionalTasks} setIsLoad={setIsLoad} setErrorMessage={setErrorMessage} /> }
            {errorMessage && <ModalWindow text={errorMessage} closeWindow={()=>setErrorMessage('')} />}
            {!isLoad &&  <Loader/>}
        </div>
    );
};

export default ConstructorPage;